module.exports = __webpack_public_path__ + "media/images/version_merge/banks/union_pay_logo-aff58e55c63a19071e3925c9a71822a0.png";